import axios from "axios";
import { GroupTermElementTypeEnum, GroupTermFunctionTypeEnum } from "Enums";
import { AxiosHelperSingleton } from "Helpers";
import { TCreateGlobalGroupRequestDTO, TGlobalSearchTerm } from "Types";

export class TermGroupController {
    public async createAsync(caseId: number, name: string, elementId: number, elementType: GroupTermElementTypeEnum,
            functionType: GroupTermFunctionTypeEnum): Promise<boolean> {
        const requestBody: TCreateGlobalGroupRequestDTO = {
            caseId: caseId,
            name: name,
            elementId: elementId,
            elementType: elementType,
            functionType: functionType
        };
        const result = await axios.post(`${AxiosHelperSingleton.getServerBaseURL()}termgroup/CreateGlobalGroup`, requestBody);
        return result.status === 200;
    }

    public async getPreviewAsync(groupId: string): Promise<TGlobalSearchTerm[]> {
        const result = await axios.get<TGlobalSearchTerm[]>(`${AxiosHelperSingleton.getServerBaseURL()}termgroup/previewJson?id=${groupId}`);
        return result.data;
    }
}

export const TermGroupControllerSingleton = new TermGroupController(); 